module.exports = __webpack_public_path__ + "images/external_images/img/1920x1080/img3.jpg";